import { _ as d, i as m } from "./index-CjjiqU7h.mjs";
import * as r from "react";
function v() {
  var e = d({}, r);
  return e.useId;
}
var u = 0, o = v();
const l = o ? (
  // Use React `useId`
  function(a) {
    var n = o();
    return a || (process.env.NODE_ENV === "test" ? "test-id" : n);
  }
) : (
  // Use compatible of `useId`
  function(a) {
    var n = r.useState("ssr-id"), i = m(n, 2), s = i[0], t = i[1];
    return r.useEffect(function() {
      var c = u;
      u += 1, t("rc_unique_".concat(c));
    }, []), a || (process.env.NODE_ENV === "test" ? "test-id" : s);
  }
), f = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), $ = (e) => ({
  animationDuration: e,
  animationFillMode: "both"
}), g = function(e, a, n, i) {
  const t = (arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1) ? "&" : "";
  return {
    [`
      ${t}${e}-enter,
      ${t}${e}-appear
    `]: Object.assign(Object.assign({}, f(i)), {
      animationPlayState: "paused"
    }),
    [`${t}${e}-leave`]: Object.assign(Object.assign({}, $(i)), {
      animationPlayState: "paused"
    }),
    [`
      ${t}${e}-enter${e}-enter-active,
      ${t}${e}-appear${e}-appear-active
    `]: {
      animationName: a,
      animationPlayState: "running"
    },
    [`${t}${e}-leave${e}-leave-active`]: {
      animationName: n,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
};
export {
  g as i,
  l as u
};
//# sourceMappingURL=motion-tF0n3Dbk.mjs.map
